<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="!loadingData">
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto"
      >
        <span class="float-right">
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreOverview'}"
                @click="showStoreOverview"
              >
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreProducts' || $route.name === 'ViewProduct'}"
                @click="showStoreProducts"
              >
                <v-list-item-title>{{ $t('products') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreOrders' || $route.name === 'ViewOrder'}"
                @click="showStoreOrders"
              >            
                <v-list-item-content>
                  <v-list-item-title>{{ $t('orders') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="ma-2" v-if="storeOrdersStatistics.filter(x => x.attributes.approved === null).length > 0"  data-testid="notification-orders-icon">
                  <v-icon class="mt-1" color="orange" >mdi-information</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreCustomers' || $route.name === 'ViewStoreCustomer'}"
                @click="showStoreCustomers"
              >
                <v-list-item-title>{{ $t('customers') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="text-h5 font-weight-bold" :align="mobile() ? 'center' : 'left'">
          {{ $t('storeTitle') }}
        </p>
      </v-col>
      <v-col cols="11" class="mx-auto">
        <v-row>
          <v-col
            v-if="!mobile()"
            cols="10"
            class="mx-auto custom-tab-menu py-0"
          >
            <v-list
              class="py-0"
              flat
            >
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreOverview'}"
                @click="showStoreOverview"
              >
                {{ $t('overview') }}
              </v-list-item> 
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreProducts' || $route.name === 'ViewProduct'}"
                @click="showStoreProducts"
              >
                {{ $t('products') }}
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreOrders' || $route.name === 'ViewOrder'}"
                @click="showStoreOrders"
              >
                <v-list-item-content>       
                  <v-list-item-title>{{ $t('orders') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="ma-2" v-if="storeOrdersStatistics && storeOrdersStatistics.filter(x => x.attributes.approved === null).length > 0"  data-testid="notification-orders-icon">
                  <v-icon class="mt-1" color="orange" >mdi-information</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active accent--text': $route.name === 'StoreCustomers' || $route.name === 'ViewStoreCustomer'}"
                @click="showStoreCustomers"
              >
                {{ $t('customers') }}
              </v-list-item>
            </v-list> 
          </v-col>
          <v-col 
              :cols="mobile() ? '12' : '2'"
              class="mx-auto d-flex align-end justify-end" align="right"
          >
              <v-tooltip
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="d-block mb-2"
                    data-testid="store-settings-icon"
                    color="darktext"
                    v-on="on"
                    @click="openEditStoreSettingsDialog"
                  >
                    mdi-cog
                  </v-icon>
                </template>
                <span>{{ $t('storeSettingsBlock') }}</span>
              </v-tooltip>
              <!-- approved order -->
              <v-tooltip
                bottom
                v-if="isOrderApproved && routeViewOrder == true" 
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on"
                    ref="download" 
                    data-testid="download-pdf-button" 
                    elevation="0" 
                    class="rounded-xxl text-none" 
                    @click="downloadData()" 
                    :loading="downloadingPDF"
                  >
                    <v-icon class="pl-1"> mdi-tray-arrow-down </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('downloadOrderStatisticsTooltip') }}</span>
              </v-tooltip>
              <v-tooltip
                bottom
                v-if="isOrderApproved && routeViewOrder == true" 
              >
                <template v-slot:activator="{ on }">
                  <v-btn 
                  v-on="on" 
                  ref="choose-customer" 
                  v-if="isOrderApproved && routeViewOrder == true" 
                  data-testid="choose-customer-button" 
                  elevation="0" 
                  class="rounded-xxl text-none" 
                  :to="link.route" 
                  color="warning"
                >
                  <v-icon class="pl-1" color="darktext"> mdi-account-box-plus-outline</v-icon>
                </v-btn> 
                </template>
                <span>{{ $t('attachCustomerTitle') }}</span>
              </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <router-view v-if="!loadingData" :role="role"></router-view>
      <EditStoreSettings
        v-if="visibleDialogEditStoreSettings"
        :visible="visibleDialogEditStoreSettings"
        @proceedAction="proceedAction"
        @close="visibleDialogEditStoreSettings = false"
      />
  </nav>
</template>

<script>
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import EditStoreSettings from './EditStoreSettings'
import i18n from '../../plugins/i18n'
import { downloadOrderData } from '../../api/productApi'

export default {
    components: {
        AlertMessages,
        EditStoreSettings
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            alertMsg:'',
            alertType:'',
            alertValue:false,
            loadingData: false,
            role:'',
            visibleDialogEditStoreSettings: false,
            panddingOrders: false,
            storeOrders: [],
            spaceId: window.$cookies.get('space_id'),
            orderID: this.$route.params.id, 
            downloadingPDF: false,
            routeViewOrder: false,
            link: {title: i18n.t('attachCustomerTitle'), route: this.$route.params.id+'/add-to-customer'},
        }
    },

    computed: {
      storeOrdersStatistics() {
          return this.$store.state.storeOrdersStatistics
      },
      isOrderApproved() {
        const orderStatistic = this.storeOrdersStatistics.find(statistic => statistic.id === this.orderID)
        return orderStatistic ? orderStatistic.attributes.approved : false
      },
    },

     mounted() {
      this.getStoreOrdersAll()
      if(this.$route.name === 'ViewOrder'){
        this.routeViewOrder = true
      }
    },
    methods:{
        proceedAction(msg, type){
            if(type == 'success'){
                this.loadingData = true
                this.visibleDialogEditStoreSettings = false
                this.alertType= type
                this.alertMsg = msg
            }
            if(type == 'error'){
                this.loadingData = true
                this.visibleDialogEditStoreSettings = false
                this.alertType= type
                this.alertMsg = msg
            }
            this.alertValue = true
            this.loadingData = false
        },
        openEditStoreSettingsDialog(){
            this.visibleDialogEditStoreSettings = true
            
        },
        showStoreOverview(){
            if (this.$route.name != 'StoreOverview') {
                this.$router.push({path: '/store/overview'})
            }
        },
        showStoreProducts(){
            if (this.$route.name != 'StoreProducts') {
                this.$router.push({path: '/store/products'})
            }
        },
        showStoreOrders(){
            if (this.$route.name != 'StoreOrders') {
                this.$router.push({path: '/store/orders'})
            }
        },
        showStoreCustomers(){
            if (this.$route.name != 'StoreCustomers') {
                this.$router.push({path: '/store/customers'})
            }
        },
        getStoreOrdersAll(){
            this.$store.dispatch("getStoreOrdersAll", this.spaceId).catch(() => {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg =  i18n.t('serverError')  
      })
    },
    async downloadData() {
      this.downloadingPDF =true
      try {
        const response = await downloadOrderData(this.orderID);
        if (response.status) {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Order-statistics.pdf');
            document.body.appendChild(link);
            link.click();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
      this.downloadingPDF =false
    },
    },
}
</script>
